import { render, staticRenderFns } from "./RecommendationCarousel.vue?vue&type=template&id=83daa716&scoped=true&"
import script from "./RecommendationCarousel.vue?vue&type=script&lang=js&"
export * from "./RecommendationCarousel.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationCarousel.vue?vue&type=style&index=0&id=83daa716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83daa716",
  null
  
)

export default component.exports